module.exports = __webpack_public_path__ + "img/mood1.7e997da7.png";